/*
 * @Description: 全局btn loading 控制 配合mixin 使用
 * @Author: wjx
 * @Date: 2018-04-28 14:12:46
 * @LastEditors: wjx
 * @LastEditTime: 2019-06-14 19:18:12
 */
const loading = {
  state: {
    btLoading: false // 提交按钮状态
  },

  mutations: {
    SET_BTLOADING: (state, item) => {
      state.btLoading = item;
    }
  },

  actions: {}
};

export default loading;
